import { createContext, useContext, useState, useEffect } from "react";

const STORAGE_KEY = "a11y_settings";

const defaults = {
  highContrast: false,
  fontSize: "normal", // "small" | "normal" | "large" | "xlarge"
};

const AccessibilityContext = createContext(null);

export function AccessibilityProvider({ children }) {
  const [settings, setSettings] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? { ...defaults, ...JSON.parse(raw) } : defaults;
    } catch {
      return defaults;
    }
  });

  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch {}

    const html = document.documentElement;

    html.classList.toggle("a11y-high-contrast", settings.highContrast);

    html.classList.remove("a11y-text-small", "a11y-text-large", "a11y-text-xlarge");
    if (settings.fontSize !== "normal") {
      html.classList.add(`a11y-text-${settings.fontSize}`);
    }
  }, [settings]);

  const updateSetting = (key, value) =>
    setSettings((prev) => ({ ...prev, [key]: value }));

  const resetSettings = () => setSettings(defaults);

  return (
    <AccessibilityContext.Provider
      value={{ settings, updateSetting, resetSettings, sidebarOpen, setSidebarOpen }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
}

export function useAccessibility() {
  const ctx = useContext(AccessibilityContext);
  if (!ctx) throw new Error("useAccessibility must be used inside AccessibilityProvider");
  return ctx;
}
